import * as SearchMaskActions from '../actions/searchmask';
import { SearchMask } from '../../../xena/core/shared/models/searchmask.model';


export interface State {
	searchMasks: Array<SearchMask>;
	selectedSearchMask: SearchMask;
}

export const InitialState: State = {
	searchMasks: [],
	selectedSearchMask: null
};


export function reducer(state: State = InitialState, action: SearchMaskActions.All): State {
	switch (action.type) {
		case SearchMaskActions.SELECT_SEARCH_MASK:
			return { ...state, selectedSearchMask: action.payload };

		case SearchMaskActions.LOAD_SEARCH_MASK_SUCCESS:
			return { ...state, searchMasks: action.payload };

		case SearchMaskActions.SAVE_SEARCH_MASK_SUCCESS:
			return { ...state, searchMasks: state.searchMasks.concat([action.payload]) };

		case SearchMaskActions.DELETE_SEARCH_MASK_SUCCESS:
			return { ...state, searchMasks: state.searchMasks.filter(mask => mask._id !== action.payload._id) };

		case SearchMaskActions.UPDATE_SEARCH_MASK_SUCCESS:
			return {
				...state,
				searchMasks: state.searchMasks.map(mask => {
					if (mask._id === action.payload._id) {
						return action.payload;
					}

					return mask;
				})
			};

		default:
			return state;
	}
}

export const GetAll = (s: State): Array<SearchMask> => s.searchMasks;
export const GetSelected = (s: State): SearchMask => s.selectedSearchMask;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/reducers/searchmask.ts